const templatePost = (WpTag = '') => `
  databaseId
  title
  content
  date
  excerpt
  featuredImage {
    node {
      altText
      sourceUrl
      srcSet
    }
  }
  categories {
    nodes {
      slug
      name
    }
  }
  id
  slug
  tags {
    nodes {
      slug
      name
    }
  }
  uri
  template {
    ...on ${WpTag}TemplateInner {
      templateName
      templateInnerPost {
        templateInnerHero {
          templateInnerHeroTitle
          templateInnerHeroLanguage
          templateInnerHeroIframeUrl
          templateInnerHeroDescription
          templateInnerHeroBackButton
          templateInnerHeroMainButton {
            templateInnerHeroMainButtonTextUrl
            templateInnerHeroMainButtonText
          }
        }
      }
    }
    ...on ${WpTag}Template_LeadGenerator {
      templateName
      templateLeadGenerator {
        templateLeadGeneratorHero {
          templateLeadGeneratorHeroTitle
          templateLeadGeneratorHeroDescription
          templateLeadGeneratorHeroBackButton
          templateLeadGeneratorHeroBanner {
            altText
            srcSet
            sourceUrl
          }
        }
      }
    }
  }
  seo {
    canonical
    cornerstone
    focuskw
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphModifiedTime
    opengraphPublishedTime
    opengraphPublisher
    opengraphSiteName
    opengraphTitle
    opengraphType
    opengraphUrl
    readingTime
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      sourceUrl
    }
    twitterImage {
      sourceUrl
    }
    breadcrumbs {
      text
      url
    }
    schema {
      articleType
      pageType
    }
  }
`;

module.exports.templatePost = templatePost;
